import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import {
  WidgetUrlConfig,
  getInitialWidgetConfig
} from '../widget-config/initial-config';
import { last } from 'lodash';

@Injectable()
export class WidgetConfigResolver implements Resolve<WidgetUrlConfig> {
  constructor() {}

  resolve(route: ActivatedRouteSnapshot) {
    const params = { ...route.queryParams };

    // sanitize the possibility of the same param being included more than once.
    // i.e. &ui-info=false&ui-info=true
    // Rule: take the first one.

    const dedupedParams = Object.keys(params).reduce((acc, param) => {
      const hasDuplicate = Array.isArray(params[param]);
      acc[param] = hasDuplicate ? last(params[param]) : params[param];
      return acc;
    }, {});

    return getInitialWidgetConfig(dedupedParams);
  }
}
